// extracted by mini-css-extract-plugin
module.exports = {"root":"TicketTiersEditor_root__PGpD4","addTierButton":"TicketTiersEditor_addTierButton__146n1"};